import { safeGetLocalStorage } from './safeStorage';

const LAST_ADVISOR_GROUP_ID_KEY = 'wa:lastSignedInAdvisorGroupId';

function parseAdvisorGroupId(raw: string | null): number | null {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) return null;
  const asNumber = Number(trimmed);
  if (!Number.isFinite(asNumber)) return null;
  if (!Number.isInteger(asNumber)) return null;
  if (asNumber <= 0) return null;
  return asNumber;
}

export function setLastSignedInAdvisorGroupId(advisorGroupId: number): void {
  if (!Number.isInteger(advisorGroupId) || advisorGroupId <= 0) return;
  const storage = safeGetLocalStorage();
  if (!storage) return;
  try {
    storage.setItem(LAST_ADVISOR_GROUP_ID_KEY, String(advisorGroupId));
  } catch {
    // ignore
  }
}

export function getLastSignedInAdvisorGroupId(): number | null {
  const storage = safeGetLocalStorage();
  if (!storage) return null;
  return parseAdvisorGroupId(storage.getItem(LAST_ADVISOR_GROUP_ID_KEY));
}
